
const ORDERS_RECEIVED = (state, data) => {
    state.orders = data;
}

const USER_DATA_RECEIVED = (state, data) => {
    state.userdata = data;
}

export default {
    ORDERS_RECEIVED,
    USER_DATA_RECEIVED
}